import {Button, MenuItem} from '@material-ui/core';
import * as I from 'immutable';
import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import OutlinedSelect from 'Shared/components/OutlinedSelect';
import {Scope} from 'Shared/constants/Scope';
import {hasAccessToScopeByApplication} from 'Shared/utilities/applicationId';
import {Application} from 'Users/models/Application';
import {LineOfBusiness} from 'Users/models/LineOfBusiness';
import {User} from 'Users/models/User/User';
import {isAgentUserType, isQuotingUserType, UserType} from 'Users/models/User/UserType';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';
import './LineOfBusinessSelect.sass';
import { ReducerState } from 'rootReducer';
import { isValidVIPUserType } from 'Users/models/User/AgentUserType';
import { isQuotingAdminUserType } from 'Users/models/User/QuotingUserType';

type LineOfBusinessSelectProps = {
  onSelectLineOfBusiness: (lineOfBusiness: LineOfBusiness) => void;
  user: User;
  isExternal: boolean
};

const LineOfBusinessSelect = (props: LineOfBusinessSelectProps) => {
  const [lineOfBusiness, setLineOfBusiness] = useState<LineOfBusiness | ''>('');
  const {BR_QuotingTool} = useSelector((state: ReducerState) => state.featureFlag);
  const {user, onSelectLineOfBusiness, isExternal} = props;
  const userTypes: I.List<UserType> = user.userTypes;
  const userTypeValues = userTypes.map(ut => ut.value);
  const userRolesValues = userTypeValues.map(ut => ut.value)

  const scopes = useSelector(selectUserScopes);

  return (
    <div className="line-of-business-entry">
      <OutlinedSelect
        label="Line of Business"
        className="line-of-business-entry__select"
        value={lineOfBusiness}
        onChange={e => setLineOfBusiness(parseInt(e.target.value, 10) as LineOfBusiness)}
      >
        <MenuItem
          value={LineOfBusiness.Agent}
          disabled={
            userTypeValues.some(isAgentUserType) ||
            !hasAccessToScopeByApplication(scopes, Scope.AddUser, Application.Agent)
          }
        >
          Agent
        </MenuItem>
        {BR_QuotingTool && (
        <MenuItem
          value={LineOfBusiness.Quoting}
          disabled={
            isExternal ||
            userTypeValues.some(isQuotingUserType) ||
            !hasAccessToScopeByApplication(scopes, Scope.AddUser, Application.Quoting) ||
            (userTypeValues.some(isAgentUserType) && !userRolesValues.some(isValidVIPUserType))
          }
        >
          Quoting
        </MenuItem>
       )}
      </OutlinedSelect>
      <Button
        className="line-of-business-entry__add-access-button"
        color="primary"
        variant="contained"
        disabled={
          lineOfBusiness === '' || 
          ( userTypeValues.some(isAgentUserType) && !userRolesValues.some(isValidVIPUserType)
            && 
            userTypeValues.some(isQuotingUserType)
          )
        }
        onClick={() => {
          if (lineOfBusiness !== '') {
            onSelectLineOfBusiness(lineOfBusiness);
            setLineOfBusiness('');
          }
        }}
      >
        Add Access
      </Button>
    </div>
  );
};

export default LineOfBusinessSelect;
